<div class="quantity-pool">
  <div class="pallet-card">
    <div class="pallet-card__body">
      <lib-pallet-number class="pallet-card__number"></lib-pallet-number>

      <div class="quantity">
        <div class="quantity__wrapper">
          <div class="quantity__label">{{ 'PALLET_CARD.GROSS_QUANTITY' | translate }}</div>
          <div class="quantity__value">
            {{ grossQuantity | formatQuantity : false }}
            <span class="quantity__units">{{ grossQuantity.unitId | formatUnitId }}</span>
          </div>
        </div>
      </div>

      <div *ngIf="showButtons" class="pallet-card__actions">
        <div class="form-group">
          <lib-split-button class="quantity-pool__action" [loadingTopic]="LOADING_TOPIC" [items]="poolButtons"></lib-split-button>
        </div>
      </div>
    </div>
  </div>
</div>
